import store from '@/store'

const transformDictData = (key, value) => {
  const dictData = store.state.dictData
  if (dictData[key]) {
    const res = dictData[key].find(item => item.dm === value) || {}
    return res.mc || ''
  }
  return ''
}

export default transformDictData



// WEBPACK FOOTER //
// ./src/filters/dictDataTransform.js